// extracted by mini-css-extract-plugin
module.exports = {"mountingBracketImgWrapper":"MountingBracketSelector_mountingBracketImgWrapper__7eQUT"};